module.exports = __webpack_public_path__ + "static/media/68.e5cddba8.jpg";